module.exports = __webpack_public_path__ + "static/media/icn_random.d25c2b31.svg";